module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "swiper-container gallery-top swiper-container-horizontal"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.imgArray), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "swiper-slide",
      style: ({
        background: 'url(' + _vm.imgArray[i].image_url + ')no-repeat center'
      })
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    staticStyle: {
      "position": "absolute"
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "memberContent"
  }, [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clickMore",
    on: {
      "click": _vm.clickMore
    }
  }, [_vm._v("了解更多")])])]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('footerBottomer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "center",
      "background-color": "#fcfcfc"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "793px"
    },
    attrs: {
      "src": require("../../site/mapBanner.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "titleIntro"
  }, [_c('p', {
    staticClass: "titleTxt"
  }, [_vm._v("糖糖圈誓言")]), _vm._v(" "), _c('p', {
    staticClass: "titleEnglish"
  }, [_vm._v("Tang Tang Quan Oath")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px",
      "font-size": "14px",
      "color": "#999",
      "text-align": "center",
      "line-height": "25px"
    }
  }, [_c('p', [_vm._v("糖糖圈致力于糖尿病教育事业，奉行人道主义精神，坚守“以病人为中心”的信念，履行“保存生命，减轻痛苦，")]), _vm._v(" "), _c('p', [_vm._v("促进健康”的职责。健康所系，性命相托!我们决心竭尽全力减少病人因糖尿病带来的痛苦，")]), _vm._v(" "), _c('p', [_vm._v("让1型糖尿病患者生活得既有质量又有尊严!")])]), _vm._v(" "), _c('div', {
    staticClass: "serviceContent"
  }, [_c('div', {
    staticClass: "serviceLeft left"
  }, [_c('img', {
    attrs: {
      "src": require("../../site/intro1.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "serviceRight right"
  }, [_c('div', {
    staticClass: "serviceTitle"
  }, [_vm._v("标准化照护服务")]), _vm._v(" "), _c('div', {
    staticClass: "serviceTxt"
  }, [_vm._v("\n          糖糖圈糖尿病多学科医疗团队共同照护服务，服务周期长达终身， 通过密集干预和定期随访的形式，提供便捷、不间断、个体化、 专业的高端糖尿病管理服务，确保患者长期有效的自我管理， 致力于以最大限度保障患者的生活质量，维持最佳健康状态， 让患者拥有更愉快便捷的正常生活，摆脱疾病及并发症困扰。  \n        ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "serviceContent"
  }, [_c('div', {
    staticClass: "serviceLeft left"
  }, [_c('div', {
    staticClass: "serviceTitle"
  }, [_vm._v("甜蜜讲堂直播")]), _vm._v(" "), _c('div', {
    staticClass: "serviceTxt"
  }, [_vm._v("\n          定期邀请国内知名内分泌专家教授、医生，营养师，控糖达人，糖友家长， 糖尿病教育师，心理医生等进行线上，以视频直播的形式，传授知识和经 验，并在线答疑解惑，我们已经进行了150多期，非常适合您进入学习。\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "serviceRight right"
  }, [_c('img', {
    attrs: {
      "src": require("../../site/intro2.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "serviceContent"
  }, [_c('div', {
    staticClass: "serviceLeft left"
  }, [_c('img', {
    attrs: {
      "src": require("../../site/intro3.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "serviceRight right"
  }, [_c('div', {
    staticClass: "serviceTitle"
  }, [_vm._v("线上公益咨询")]), _vm._v(" "), _c('div', {
    staticClass: "serviceTxt"
  }, [_vm._v("\n          便捷的线上咨询医生已成功帮助上万糖友完成线上问诊服务 医生+患教师+营养师+心理师教您进阶血糖教育 把“神秘”控糖技能告诉您。  \n        ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "serviceContent"
  }, [_c('div', {
    staticClass: "serviceLeft left"
  }, [_c('div', {
    staticClass: "serviceTitle"
  }, [_vm._v("线下糖尿病诊所")]), _vm._v(" "), _c('div', {
    staticClass: "serviceTxt"
  }, [_vm._v("\n          爱宝惟诊所是全国首家1型糖尿病专科诊所由内分泌专科医师、糖尿病教育师、 营养师、心理咨询师等组成，依据并遵从“循证”的医学诊疗方法，为患者提供 国际标准的医疗服务。诊所充分考虑1型患者深层次需求，秉持“让1型糖尿病生 活更美好”的服务理念。诊所设置患者教育、营养、 检验、心理等多个科目。\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "serviceRight right"
  }, [_c('img', {
    attrs: {
      "src": require("../../site/intro4.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "titleIntro"
  }, [_c('p', {
    staticClass: "titleTxt"
  }, [_vm._v("其他功能")]), _vm._v(" "), _c('p', {
    staticClass: "titleEnglish"
  }, [_vm._v("The Other Features")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "auto",
      "width": "1200px"
    }
  }, [_c('div', {
    staticClass: "functionList left"
  }, [_c('img', {
    attrs: {
      "src": require("../../site/function1.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "functionTitle"
  }, [_vm._v("专业课程")]), _vm._v(" "), _c('div', {
    staticClass: "functionTxt"
  }, [_vm._v("由资深调糖专家制作"), _c('br'), _vm._v("涉及调糖、调针、调泵，营养和心理等"), _c('br'), _vm._v("高效助力自我管理")])]), _vm._v(" "), _c('div', {
    staticClass: "functionList left",
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../site/function2.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "functionTitle"
  }, [_vm._v("同伴互动")]), _vm._v(" "), _c('div', {
    staticClass: "functionTxt"
  }, [_vm._v("这里是1型糖友专属家园"), _c('br'), _vm._v("尽情分享、提问、总结经验"), _c('br'), _vm._v("糖友互帮互助，营造家的温暖")])]), _vm._v(" "), _c('div', {
    staticClass: "functionList left",
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../site/function3.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "functionTitle"
  }, [_vm._v("食物库")]), _vm._v(" "), _c('div', {
    staticClass: "functionTxt"
  }, [_vm._v("多达30多万种食物"), _c('br'), _vm._v("快速查询想要查的食物营养素"), _c('br'), _vm._v("重量标尺快速快捷计算营养素含量")])]), _vm._v(" "), _c('div', {
    staticClass: "functionList left",
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../site/function4.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "functionTitle"
  }, [_vm._v("血糖日历")]), _vm._v(" "), _c('div', {
    staticClass: "functionTxt"
  }, [_vm._v("独有算法评估控糖情况"), _c('br'), _vm._v("不同颜色标识，一目了然"), _c('br'), _vm._v("帮助糖友控糖的好帮手")])]), _vm._v(" "), _c('div', {
    staticClass: "functionList left"
  }, [_c('img', {
    attrs: {
      "src": require("../../site/function5.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "functionTitle"
  }, [_vm._v("实惠商城")]), _vm._v(" "), _c('div', {
    staticClass: "functionTxt"
  }, [_vm._v("生活不容易、耗材不能报销、经济负担重？"), _c('br'), _vm._v("糖糖圈商城帮糖友集采"), _c('br'), _vm._v("只会降价，加入会员还能更省钱")])]), _vm._v(" "), _c('div', {
    staticClass: "functionList left",
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../site/function6.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "functionTitle"
  }, [_vm._v("医保汇总")]), _vm._v(" "), _c('div', {
    staticClass: "functionTxt"
  }, [_vm._v("汇集全国1型医保政策"), _c('br'), _vm._v("助糖友快速了解本地医疗政策"), _c('br'), _vm._v("长期推动1型医保制度完善")])]), _vm._v(" "), _c('div', {
    staticClass: "functionList left",
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../site/function7.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "functionTitle"
  }, [_vm._v("共享糖化漂流")]), _vm._v(" "), _c('div', {
    staticClass: "functionTxt"
  }, [_vm._v("还在跑医院排队测糖化？"), _c('br'), _vm._v("快来参加糖化漂流活动"), _c('br'), _vm._v("在家快速测糖化，省时省心更省钱")])]), _vm._v(" "), _c('div', {
    staticClass: "functionList left",
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../site/function8.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "functionTitle"
  }, [_vm._v("动态血糖云")]), _vm._v(" "), _c('div', {
    staticClass: "functionTxt"
  }, [_vm._v("搭建动态血糖分享网址"), _c('br'), _vm._v("实现家人远程查看血糖"), _c('br'), _vm._v("患者血糖情况全家掌握")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "titleIntro"
  }, [_c('p', {
    staticClass: "titleTxt"
  }, [_vm._v("糖糖圈会员服务")]), _vm._v(" "), _c('p', {
    staticClass: "titleEnglish"
  }, [_vm._v("Tang Tang Quan Membership Service")]), _vm._v(" "), _c('p', {
    staticClass: "titleEnglish",
    staticStyle: {
      "margin-top": "35px"
    }
  }, [_vm._v("开通终身制会员，尊享15大会员权益，糖糖圈为您终身服务")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "memberList left"
  }, [_c('img', {
    attrs: {
      "src": require("../../site/icon1.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "memberTxt"
  }, [_vm._v("1对1血糖管理")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "memberList left"
  }, [_c('img', {
    attrs: {
      "src": require("../../site/icon2.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "memberTxt"
  }, [_vm._v("会员商城折扣")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "memberList left"
  }, [_c('img', {
    attrs: {
      "src": require("../../site/icon3.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "memberTxt"
  }, [_vm._v("泵定制优惠")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "memberList left"
  }, [_c('img', {
    attrs: {
      "src": require("../../site/icon4.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "memberTxt"
  }, [_vm._v("共享糖化漂流")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "memberList left"
  }, [_c('img', {
    attrs: {
      "src": require("../../site/icon5.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "memberTxt"
  }, [_vm._v("动态血糖云")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "memberList left"
  }, [_c('img', {
    attrs: {
      "src": require("../../site/icon6.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "memberTxt"
  }, [_vm._v("定制讲堂主题")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "memberList left"
  }, [_c('img', {
    attrs: {
      "src": require("../../site/icon7.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "memberTxt"
  }, [_vm._v("线下医疗照护")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "100px",
      "padding": "100px 0px",
      "background-color": "#fcfcfc"
    }
  }, [_c('div', {
    staticClass: "titleIntro"
  }, [_c('p', {
    staticClass: "titleTxt",
    staticStyle: {
      "margin-top": "0"
    }
  }, [_vm._v("合作伙伴")]), _vm._v(" "), _c('p', {
    staticClass: "titleEnglish"
  }, [_vm._v("Cooperative Partner")])]), _vm._v(" "), _c('div', {
    staticClass: "partnerContent"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_c('img', {
    staticStyle: {
      "margin-left": "45px"
    },
    attrs: {
      "src": require("../../site/ttq1.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../site/ttq2.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../site/ttq3.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../site/ttq4.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../site/ttq5.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../site/ttq6.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('img', {
    staticStyle: {
      "margin-left": "45px"
    },
    attrs: {
      "src": require("../../site/ttq7.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../site/ttq8.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../site/ttq9.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../site/ttq10.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../site/ttq11.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../site/ttq12.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('img', {
    staticStyle: {
      "margin-left": "45px"
    },
    attrs: {
      "src": require("../../site/ttq13.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../site/ttq14.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../site/ttq15.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../site/ttq16.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../site/ttq17.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../site/ttq18.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('img', {
    staticStyle: {
      "margin-left": "45px"
    },
    attrs: {
      "src": require("../../site/ttq19.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../site/ttq20.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../site/ttq21.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../site/ttq22.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../site/ttq23.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../site/ttq24.png")
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a73d8e46","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/index.vue
// module id = 192
// module chunks = 1